<template>
	<a-config-provider :locale="zh_CN">
		<!-- 微信浏览器提示 -->
<!--		<div v-if="false" class="wechat-tip">-->
<!--			<div class="tip-content">-->
<!--				<div class="tip-title">请使用其他浏览器访问</div>-->
<!--				<div class="tip-message">-->
<!--					<p>检测到您正在使用微信浏览器</p>-->
<!--					<p>为了更好的浏览体验，请点击右上角菜单</p>-->
<!--					<p>选择"在浏览器中打开"</p>-->
<!--					<p>推荐使用Chrome、Firefox、Safari等浏览器</p>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<!-- 正常内容 -->
		<div  id="app">
			<router-view></router-view>
		</div>
	</a-config-provider>
</template>

<script>
	import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
	export default {
		name: 'app',
		data() {
			return {
				zh_CN,
				isWechat: false
			}
		},
		mounted() {
			// 检测是否为微信浏览器
			this.isWechat = this.isWechatBrowser();
		},
		methods: {
			// 检测是否为微信浏览器
			isWechatBrowser() {
				const ua = navigator.userAgent.toLowerCase();
				return ua.includes('micromessenger');
			}
		}
	}
</script>

<style>
	#app {
		width: 100%;
		height: 100%;
		min-height: 100%;
	}
	
	/* 微信浏览器提示样式 */
	.wechat-tip {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}
	
	.tip-content {
		background: white;
		border-radius: 10px;
		padding: 30px;
		text-align: center;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
		max-width: 90%;
	}
	
	.tip-title {
		font-size: 24px;
		font-weight: bold;
		color: #333;
		margin-bottom: 20px;
	}
	
	.tip-message {
		font-size: 16px;
		color: #666;
		line-height: 1.8;
	}
	
	.tip-message p {
		margin: 10px 0;
	}
</style>